import {useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {UPDATE_CHAT_CLEAR, UPDATE_SIGNIN} from '../../constants';
import {removeUser} from '../../actions/loginAction';

const Logout = (props) => {
  useEffect(() => {
    removeUser();
    props.logout();
    setTimeout(() => {
      props.history.push('/');
    }, 100);
  });
  return null;
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout() {
      dispatch({type: UPDATE_SIGNIN, profile: {}, manual: true, clear: true});
      dispatch({type: UPDATE_CHAT_CLEAR});
    },
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Logout))
